/**
 *
 */
export default class AppApiResponse {
  constructor (response) {
    if (!response) {
      throw new Error('null object passed to AppApiResonse as constructor')
      return
    }
    let apiResponse = {}
    if (response instanceof Error) {
      apiResponse.message = response.message
      apiResponse.type = 'error'
      apiResponse.data = {}
      if (response.code === 'ECONNABORTED') {
        // network error
      }
      if (response.hasOwnProperty('response')
        && response.response.hasOwnProperty('data')
        && response.response.data.hasOwnProperty('type')
        && response.response.data.hasOwnProperty('message')) {
        apiResponse = response.response.data
        apiResponse['data'] = response.response.data.hasOwnProperty('data') ? response.response.data.data : {}
      }
      this.setMessage(apiResponse.message)
        .setType(apiResponse.type)
        .setData(apiResponse.data)
      return
    }
    if (response.hasOwnProperty('type') && response.hasOwnProperty('message')) {
      apiResponse = response
      apiResponse['data'] = response.hasOwnProperty('data') ? response.data : {}
    } else if (response.hasOwnProperty('data')
      && response.data.hasOwnProperty('message')
      && response.data.hasOwnProperty('type')) {
      // when I am feeling lay just outputting directly the APIResponse from server
      apiResponse = response.data;
      apiResponse['data'] = response.data.hasOwnProperty('data') ? response.data.data : {}
    } else { // unknown! something went wrong
      apiResponse = {}
    }
    this.type = ''
    this.message = ''
    this.data = null
    this.isResponse = false
    if (apiResponse) {
      this.isResponse = true
      this.type = apiResponse.type
      this.message = apiResponse.message
      this.data = apiResponse.hasOwnProperty('data') ? apiResponse.data : {}
    }
  }

  isApiResponse () {
    return this.isResponse
  }

  getMessage () {
    return this.message
  }

  getType () {
    return this.type
  }

  getData () {
    // in case of laravel paginate response
    if (this.hasData() && this.data.hasOwnProperty('current_page')) {
      return this.data.data
    }

    // TODO: prepare next page link
    return this.data
  }

  setData (data) {
    this.data = data
    return this
  }

  hasData () {
    return !!this.data
  }

  isError () {
    return this.type === 'error'
  }

  isSuccess () {
    return this.type === 'success'
  }

  isWarning () {
    return this.type === 'warning'
  }

  setMessage (message) {
    this.message = message
    return this
  }

  setType (type) {
    this.type = type
    return this
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/AppApiResponse.js